/* eslint-disable camelcase */
import { Module } from 'vuex'
import { RootState } from '../types'
import api from '@/api/axios'

export interface Tenant {
  id: number
  name: string
  phone: string
  email?: string
  unit_id: number
  unit_name?: string
  property_name?: string
  rent_amount?: number
  lease_start: string
  lease_end: string
  status: 'active' | 'exited'
}

export interface TenantsState {
  list: Tenant[]
  current: Tenant | null
  loading: boolean
}

const tenants: Module<TenantsState, RootState> = {
  namespaced: true,

  state: (): TenantsState => ({
    list: [],
    current: null,
    loading: false
  }),

  getters: {
    all: (state) => state.list,
    current: (state) => state.current,
    loading: (state) => state.loading
  },

  mutations: {
    SET_LIST (state, list: Tenant[]) { state.list = list },
    SET_CURRENT (state, tenant: Tenant) { state.current = tenant },
    SET_LOADING (state, val: boolean) { state.loading = val },
    ADD (state, tenant: Tenant) { state.list.unshift(tenant) },
    UPDATE (state, updated: Tenant) {
      const i = state.list.findIndex(t => t.id === updated.id)
      if (i !== -1) state.list.splice(i, 1, updated)
    }
  },

  actions: {
    async fetchAll ({ commit }, params?: { status?: string }) {
      commit('SET_LOADING', true)
      try {
        const { data } = await api.get('/tenants', { params })
        commit('SET_LIST', data.data ?? data)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async fetchOne ({ commit }, id: number) {
      const { data } = await api.get(`/tenants/${id}`)
      commit('SET_CURRENT', data.data ?? data)
    },

    async create ({ commit }, payload: Partial<Tenant>) {
      const { data } = await api.post('/tenants', payload)
      commit('ADD', data.data ?? data)
      return data
    },

    async update ({ commit }, { id, ...payload }: Partial<Tenant> & { id: number }) {
      const { data } = await api.put(`/tenants/${id}`, payload)
      commit('UPDATE', data.data ?? data)
      return data
    }
  }
}

export default tenants
